import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Modal } from "@campgladiator/cgui-core.molecules.modal";
import React from "react";
import useWithCancelMembershipModal from "./useWithCancelMembershipModal";
import { Dropdown } from "@campgladiator/cgui-core.atoms.dropdown";
import {
  CancellationReason,
  SubscriptionDTO,
} from "@campgladiator/cg-common.types.types";
import styles from "./CancelMembershipModal.module.scss";
import { formatDateString } from "@campgladiator/cg-common.utility.dates";
import { ButtonProps } from "@campgladiator/cgui-core.atoms.button";

export type CancelMembershipModalProps = {
  cancelAtDate: string;
  isLoading: boolean;
  isVisible: boolean;
  onClose: (success?: boolean) => void;
  onFormSubmit: (reason: CancellationReason) => void;
  subscription: SubscriptionDTO;
  theme: ButtonProps["theme"];
};

const CancelMembershipModal = ({
  isVisible,
  onClose,
  subscription,
  onFormSubmit,
  isLoading,
  cancelAtDate,
  theme,
}: CancelMembershipModalProps) => {
  const {
    cancelRetainText,
    modalTitle,
    modalButtons,
    isToCancel,
    cancellationReasonOptions,
    cancellationDateText,
    cancellationDisclaimerText,
    handleSelectReasonOption,
  } = useWithCancelMembershipModal({
    onClose,
    subscription,
    onFormSubmit,
    isLoading,
    theme,
  });
  return (
    <Modal
      isVisible={isVisible}
      title={modalTitle}
      onClose={() => onClose(undefined)}
      buttons={modalButtons}
      className={styles.modal}
    >
      <div className={styles.content}>
        {!isToCancel && (
          <div className={styles.intro}>
            {cancelRetainText && (
              <Paragraph size="xsmall">{cancelRetainText}</Paragraph>
            )}
            <Paragraph weight="book" size="default">
              {cancellationDisclaimerText}
            </Paragraph>
            <Paragraph weight="book" size="default">
              {cancellationDateText}: {formatDateString(cancelAtDate)}
            </Paragraph>
          </div>
        )}
        {isToCancel && (
          <div className={styles.reason}>
            <Dropdown
              options={cancellationReasonOptions}
              onChangeSelectedOption={handleSelectReasonOption}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CancelMembershipModal;
